import GameList from '../game/list/GameList.vue';

export default {
  name: 'Promotion',
  components: { GameList },
  data() {
    return {
      dialog01: false,
      dialog02: false,
      currentAction: null,
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    currentActions() {
      return this.$store.state.sales.currentActions;
    },
    actions() {
      return this.$store.state.sales.actions;
    },
  },

  methods: {
    openProductList(action) {
      window.open(action.pdf_detail_file_url, '_blank');
    },
    openInstructions(action) {
      window.open(action.pdf_file_url, '_blank');
    },
    detailedClicked(action) {
      this.currentAction = action;
      this.dialog01 = true;
    },
    /** Покупка или монтаж */
    isSale(action) {
      return action.button_type === 'sale';
    },
    /** Добавить покупку */
    addSale(action) {
      const table = action.show_products_in_table === 1;
      if (this.isSale(action)) {
        this.$router.push(`/sale/${table ? 'table/' : ''}${action.id}/null`);
      } else {
        this.$router.push(`/sale-fns/${table ? 'table/' : ''}${action.id}/null`);
      }
    },
    /** Подтвердить участие в акции */
    confirmAction(actionId) {
      this.$store.dispatch('sales/ConfirmAction', {
        profile_id: this.user.profile_id,
        action_id: actionId,
      });
    },
  },

  mounted() {
    this.$store.dispatch('SetTitle', 'Конкурсы / Акции');
    this.$store.dispatch('sales/GetActionsList', {
      profile_id: this.user.profile_id,
    });
    this.$store.dispatch('sales/GetActions', {
      profile_id: this.$store.state.user.profile_id,
    });
  },
};
